<div class="mainpanel" [hidden]="!ViewReady">
    <h2 class="mat-title">
        Nomination Window Dates Editor<span *ngIf="AwardInfo"> - {{ AwardInfo.BannerName }}</span>
    </h2>
    <div>
        <div>
            Listed below are all defined nomination window dates for the current school year and awards program. Use the provided buttons to
            edit the window dates as needed. Note: Certain window dates cannot exceed other window dates by design. (For example, individual
            window dates for a photo or video submission must lie within the overall window for the entire nomination process, as
            applicable.)
        </div>
        <div
            class="buttongroup"
            fxLayout="row"
            fxLayoutAlign="start start"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start center"
            *ngIf="ShowingWindowPanel !== true"
        >
            <button mat-raised-button color="primary" (click)="ShowWindowPanel()" [disabled]="ShowingWindowPanel">
                Add New Nomination / Judging Window
            </button>
        </div>
    </div>
    <div *ngIf="ShowingWindowPanel" class="mat-elevation-z12 entrypanel" style="margin-bottom:20px">
        <form [formGroup]="WindowEntryForm" novalidate fxLayout="column">
            <h2>
                <span *ngIf="WindowEntryForm.get('NominationWindowID')?.value != null"
                    >{{ WindowEntryForm.get('NomineeTypeID')?.value | nomineeType: AvailableNomineeTypes }} ({{
                        WindowEntryForm.get('WindowTypeID')?.value | windowType: AvailableWindowTypes
                    }})</span
                >
                <span *ngIf="WindowEntryForm.get('NominationWindowID')?.value == null">New Window</span>
            </h2>
            <div fxLayout="column" fxLayoutAlign="start start">
                <div *ngIf="WindowEntryForm.get('NominationWindowID')?.value == null"
                     fxLayout="row wrap"
                     fxLayoutAlign="start center"
                     fxLayoutGap="25px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <app-form-label [required]="true">Nominee Type: </app-form-label>
                        <mat-form-field appearance="outline">
                            <mat-select matInput formControlName="NomineeTypeID" placeholder="Select Nominee Type...">
                                <mat-option>Select Nominee Type...</mat-option>
                                <mat-option *ngFor="let ntype of AvailableNomineeTypes" [value]="ntype.NomineeTypeID">
                                    {{
                                    ntype.Description
                                    }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="
                                    WindowEntryForm.get('NomineeTypeID')?.hasError('required') &&
                                    WindowEntryForm.get('NomineeTypeID')?.dirty
                                ">Nominee type required</mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <app-form-label [required]="true">Window Type:</app-form-label>
                        <mat-form-field appearance="outline">
                            <mat-select matInput formControlName="WindowTypeID" placeholder="Select Window Type...">
                                <mat-option>Select Window Type...</mat-option>
                                <mat-option *ngFor="let wtype of AvailableWindowTypes" [value]="wtype.WindowTypeID">
                                    {{
                                    wtype.Description
                                    }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" *ngIf="FormWindow">
                        <app-form-label [required]="true">Form Template:</app-form-label>
                        <mat-form-field appearance="outline">
                            <mat-select matInput formControlName="FormTemplateID" placeholder="Select Form Template...">
                                <mat-option>Select Form Template...</mat-option>
                                <mat-option *ngFor="let wtype of AvailableFormTemplates" [value]="wtype.FormTemplateID">
                                    {{
                                    wtype.Name
                                    }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="15px">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <app-form-label [required]="true">Beginning Date:</app-form-label>
                        <mat-form-field appearance="outline">
                            <input type="text" matInput formControlName="DateBeginDate" [matDatepicker]="beginpicker" />
                            <mat-error
                                *ngIf="
                                    WindowEntryForm.get('DateBeginDate')?.hasError('required') &&
                                    WindowEntryForm.get('DateBeginDate')?.dirty
                                "
                                >Beginning date required</mat-error
                            >
                            <mat-datepicker-toggle matSuffix [for]="beginpicker"></mat-datepicker-toggle>
                            <mat-datepicker #beginpicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <app-form-label [required]="true">Beginning time:</app-form-label>
                        <mat-form-field appearance="outline">
                            <input type="text" matInput formControlName="DateBeginTime" placeholder="Beginning time..." />
                            <mat-hint *ngIf="!WindowEntryForm.get('DateBeginTime')?.errors">HH:MM AM/PM format</mat-hint>
                            <mat-error
                                *ngIf="
                                    WindowEntryForm.get('DateBeginTime')?.hasError('required') &&
                                    WindowEntryForm.get('DateBeginTime')?.dirty
                                "
                                >Beginning time required</mat-error
                            >
                            <mat-error
                                *ngIf="
                                    WindowEntryForm.get('DateBeginTime')?.hasError('pattern') && WindowEntryForm.get('DateBeginTime')?.dirty
                                "
                                >Invalid Format (HH:MM AM/PM required)</mat-error
                            >
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                            <app-form-label [required]="true">Ending Date:</app-form-label>
                            <mat-form-field appearance="outline">
                                <input type="text" matInput formControlName="DateEndDate" [matDatepicker]="endpicker" />
                                <mat-error
                                    *ngIf="
                                        WindowEntryForm.get('DateEndDate')?.hasError('required') &&
                                        WindowEntryForm.get('DateEndDate')?.dirty
                                    "
                                    >Ending date required</mat-error
                                >
                                <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
                                <mat-datepicker #endpicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <app-form-label [required]="true">Ending time:</app-form-label>
                        <mat-form-field appearance="outline">
                            <input type="text" matInput formControlName="DateEndTime" placeholder="Ending time..." />
                            <mat-hint *ngIf="!WindowEntryForm.get('DateEndTime')?.errors">HH:MM AM/PM format</mat-hint>
                            <mat-error
                                *ngIf="
                                    WindowEntryForm.get('DateEndTime')?.hasError('required') && WindowEntryForm.get('DateEndTime')?.dirty
                                "
                                >Ending time required</mat-error
                            >
                            <mat-error
                                *ngIf="WindowEntryForm.get('DateEndTime')?.hasError('pattern') && WindowEntryForm.get('DateEndTime')?.dirty"
                                >Invalid Format (HH:MM AM/PM required)</mat-error
                            >
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
            <button
                type="button"
                *ngIf="WindowEntryForm.get('NominationWindowID')?.value == null"
                mat-raised-button
                color="primary"
                (click)="AddWindow()"
                [disabled]="!WindowEntryForm.valid"
            >
                Add
            </button>
            <button
                type="button"
                *ngIf="WindowEntryForm.get('NominationWindowID')?.value != null"
                mat-raised-button
                color="primary"
                (click)="UpdateWindow()"
                [disabled]="!WindowEntryForm.valid"
            >
                Update
            </button>
            <button type="button" mat-raised-button color="warn" (click)="CancelWindowPanel()">Cancel</button>
        </div>
    </div>

    <!-- Nomination Windows Table -->
    <table mat-table #table [dataSource]="WindowsData" matSort matSortActive="NomineeTypeName" matSortDirection="asc">
        <ng-container matColumnDef="NomineeTypeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Nominee Type</th>
            <td mat-cell *matCellDef="let win" class="centered">
                <span>{{ win.NomineeTypeID | nomineeType: AvailableNomineeTypes }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="WindowTypeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Window Type</th>
            <td mat-cell *matCellDef="let win" class="centered">
                <span>{{ win.WindowTypeID | windowType: AvailableWindowTypes }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DateBegin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Window Begin Date</th>
            <td mat-cell *matCellDef="let win" class="centered">
                <div>{{ win.DateBegin | datefns: 'M/d/yyyy h:mm a' }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="DateEnd">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Window End Date</th>
            <td mat-cell *matCellDef="let win" class="centered">
                <div>{{ win.DateEnd | datefns: 'M/d/yyyy h:mm a' }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Action(s)</th>
            <td mat-cell *matCellDef="let win" class="centered">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxLayoutWrap>
                    <button *ngIf="WindowsData.data.length > 0" mat-raised-button color="primary" (click)="ShowWindowPanel(win)" class="buttonpad">Edit Window Dates</button>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td *matCellDef="let term" [attr.colspan]="AllHeaders?.length">
                <em>There are no nomination windows defined for the current school year and awards program in the system.</em>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="AllHeaders"></tr>
        <tr mat-row *matRowDef="let row; columns: AllHeaders; let $even = even" [class.primarybackground50]="$even"></tr>
    </table>

    <mat-paginator
        #paginator
        [length]="WindowsData?.data?.length"
        [pageIndex]="0"
        [pageSize]="SmallSize ? 5 : 10"
        [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
</div>
